import { database } from "../../services/firebaseService/firebaseConfig";

const COMPANY_SETTINGS_PATH = "CompanySettings";

export const getCompanySettingsDocRef = (companyId: string) =>
  database.ref(`${COMPANY_SETTINGS_PATH}/${companyId}`);
